var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-header", {
    attrs: { loading: _vm.loading },
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function() {
          return [_c("icon-dashboard")]
        },
        proxy: true
      },
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        Dashboard\n    ")]
        },
        proxy: true
      },
      {
        key: "buttons",
        fn: function() {
          return [
            _c(
              "router-link",
              { staticClass: "f-button primary", attrs: { to: "/login" } },
              [_vm._v("Logout")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }